import { render, staticRenderFns } from "./EventAdd.vue?vue&type=template&id=7980a8d6&scoped=true"
import script from "./EventAdd.vue?vue&type=script&lang=js"
export * from "./EventAdd.vue?vue&type=script&lang=js"
import style0 from "./EventAdd.vue?vue&type=style&index=0&id=7980a8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980a8d6",
  null
  
)

export default component.exports